/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-appointments.reducer';

export const HospitalAppointmentsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalAppointmentsEntity = useAppSelector(state => state.hospitalAppointments.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalAppointmentsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalAppointments.detail.title">HospitalAppointments</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalAppointments.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalAppointmentsEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalAppointments.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalAppointmentsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalAppointments.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalAppointmentsEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.hospitalAppointments.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{hospitalAppointmentsEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalAppointments.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalAppointmentsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.hospitalAppointments.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{hospitalAppointmentsEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAppointments.appointments">Appointments</Translate>
          </dt>
          <dd>{hospitalAppointmentsEntity.appointments ? hospitalAppointmentsEntity.appointments.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAppointments.hospital">Hospital</Translate>
          </dt>
          <dd>{hospitalAppointmentsEntity.hospital ? hospitalAppointmentsEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-appointments" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-appointments/${hospitalAppointmentsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalAppointmentsDetail;
